// extracted by mini-css-extract-plugin
export default {"cart-order-button-container":"Cart_cart-order-button-container__BfTYE","cart-main-desktop":"Cart_cart-main-desktop__X4XI4","cart-main-mobile":"Cart_cart-main-mobile__FWVFI"};